import React from 'react';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';

const ArchiveModal = ({ onOk, isLoading, ...rest }) => {
  const [t] = useTranslation();
  return (
    <Modal
      okText={t('button.archive')}
      cancelText={t('button.cancel')}
      title={t('confirm.archive-title')}
      confirmLoading={isLoading}
      onOk={onOk}
      {...rest}
    >
      <span>{t('confirm.archive-message')}</span>
    </Modal>
  );
};

export default ArchiveModal;
